<template>
  <div>
    <el-dialog title="添加类型" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form size="small" :model="form" :rules="formRules" ref="form">
        <el-form-item label="桌位编号" prop="table_no" :label-width="formLabelWidth">
          <el-input v-model="form.table_no" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('类型名称')" prop="type_id" :label-width="formLabelWidth">
          <el-select v-model="form.type_id" placeholder="类型名称">
            <el-option v-for="item in type" :key="item.type_id" :label="item.type_name" :value="item.type_id"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="addTypeClick"  icon="el-icon-plus" v-auth="'/store/table/type/add'">添加类型</el-button>
        </el-form-item>
        <el-form-item :label="$t('所属区域')" prop="area_id" :label-width="formLabelWidth" >
          <el-select v-model="form.area_id" placeholder="所属区域">
            <el-option v-for="item in area_list" :key="item.area_id" :label="item.area_name" :value="item.area_id"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="addAreaClick" icon="el-icon-plus" v-auth="'/store/table/area/add'">添加区域</el-button>
        </el-form-item>
        <el-form-item :label="$t('排序')" prop="sort" :label-width="formLabelWidth">
          <el-input v-model.number="form.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">{{$t('取 消')}}</el-button>
        <el-button type="primary" @click="addUser" :loading="loading">{{$t('确 定')}}</el-button>
      </div>
    </el-dialog>
    <!--添加类型-->
    <AddType v-if="open_type_add" :open_add="open_type_add"  @closeDialog="closeTypeDialogFunc($event, 'add')"></AddType>
    <!--添加区域-->
    <AddArea v-if="open_area_add" :open_add="open_area_add"  @closeDialog="closeAreaDialogFunc($event, 'add')"></AddArea>
  </div>


</template>

<script>
  import StoreApi from '@/api/store.js';
  import AddType from '../type/add.vue';
  import AddArea from '../area/add.vue';
  export default {
    components: {
      AddType,AddArea
    },
    data() {
      return {
        form: {
          table_no: '',
          area_id: '',
          type_id: '',
          sort: 100,
        },
        formRules: {
          table_no: [{
            required: true,
            message: '请输入桌位编号',
            trigger: 'blur'
          }],
          area_id: [{
            required: true,
            message: '请选择类型名称',
            trigger: 'blur'
          }],
          type_id: [{
            required: true,
            message: '请选择所属区域',
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: '排序不能为空'
          }, {
            type: 'number',
            message: '排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
        open_type_add: false,
        open_area_add: false,
      };
    },
    props: ['open_add', 'addform', 'type','area_list'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      addTypeClick() {
        this.open_type_add = true;
      },
      closeTypeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_type_add = e.openDialog;
          if (e.type == 'success') {
            //这里需要重新获取桌子类型列表
            StoreApi.allTypeList({}, true)
              .then(data => {
                this.type = data.data.list
                let maxTypeData = this.type.reduce((prev, curr) => {
                  return prev.type_id > curr.type_id ? prev : curr;
                });
                console.log('maxTypeData',maxTypeData)
                this.form.type_id = maxTypeData.type_id
              })
              .catch(error => {

              });
          }
        }
      },

      addAreaClick() {
        this.open_area_add = true;
      },
      closeAreaDialogFunc(e, f) {
        if (f == 'add') {
          this.open_area_add = e.openDialog;
          if (e.type == 'success') {
            //这里需要重新获取区域列表
            StoreApi.allAreaList({}, true)
              .then(data => {
                this.area_list = data.data.list
                let maxAreaData = this.area_list.reduce((prev, curr) => {
                  return prev.area_id > curr.area_id ? prev : curr;
                });
                console.log('maxAreaData',maxAreaData)
                this.form.area_id = maxAreaData.area_id
              })
              .catch(error => {

              });
          }
        }
      },
      /*添加用户*/
      addUser() {
        let self = this;
        let params = self.form;
        console.log(params)
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.addTable(params).then(data => {
              self.loading = false;
              self.$message({
                message:self.$t('添加成功') ,
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }
    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/table/table/add.vue